<div class="loading-frame-wrap">
  @if(isInitialLoading) {
  <div class="loading-overlay"></div>
  }

  @if(hasEmailFeature) {
  <h3 class="mb-4">
    Khôi phục mật khẩu Email HUTECH
  </h3>

  <div class="alert alert-info mb-3 alert-dismissible">
    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
      <span aria-hidden="true">
        <i class="fal fa-times"></i>
      </span>
    </button>
    <div class="d-flex flex-start w-100">
      <div class="mr-2 hidden-md-down">
        <span class="icon-stack icon-stack-lg">
          <i class="base base-6 icon-stack-3x opacity-100 color-info-500"></i>
          <i class="base base-10 icon-stack-2x opacity-100 color-info-300 fa-flip-vertical"></i>
          <i class="fal fa-info icon-stack-1x opacity-100 color-white"></i>
        </span>
      </div>
      <div class="d-flex flex-fill">
        <div class="flex-fill">
          <span class="h5">Hướng dẫn sử dụng</span>
          <br>
          <ul class="">
            <li>
              Chức năng này cho phép bạn gửi yêu cầu khôi phục mật khẩu email HUTECH trong trường hợp quên hoặc cần đặt
              lại
              mật khẩu.
            </li>
            <li>
              Sau khi yêu cầu được gửi, bộ phận hỗ trợ sẽ tiếp nhận và xử lý, mật khẩu mới sẽ được hiển thị trực tiếp
              trên
              giao diện này khi hoàn tất.
            </li>
            <li>Thời gian xử lý có thể mất một khoảng nhất định, vui lòng quay lại sau để kiểm tra kết quả.</li>
            <li>Lưu ý: Mật khẩu mới chỉ được hiển thị trong thời gian giới hạn, vui lòng sao lưu ngay sau khi xem.</li>
          </ul>
          <!-- Be sure to add <code>aria-expanded</code> to the control element. This attribute explicitly conveys the
          current state of the collapsible element tied to the control to screen readers and similar assistive
          technologies. If the collapsible element is closed by default, the attribute on the control element should
          have a value of <code>aria-expanded="false"</code>. If you’ve set the collapsible element to be open by
          default using the <code>show</code> class, set <code>aria-expanded="true"</code> on the control instead.
          <br>
          <br>
          Learn more about this plugin on bootstrap's <a
            href="https://getbootstrap.com/docs/4.6.0/components/collapse/#accordion-example" target="_blank">official
            documentation</a>. -->
        </div>
      </div>
    </div>
  </div>



  <!-- Main Content (Only show when not loading and has email feature) -->
  <div class="recovery-container">

    <!-- Account Email Info -->
    <div class="account-info-box bg-faded">
      <h3 class="account-info-title">Thông tin</h3>
      <div class="account-info-content">
        <div class="info-row gap-10 align-items-end">
          <span class="info-label">Email HUTECH:</span>
          <span class="info-value fs-xl">{{ emailRecoveryHUTECH.email }}</span>
        </div>
      </div>
      <!-- <div class="account-note">
        <p class="note-text">
          <strong>Lưu ý:</strong> Yêu cầu khôi phục sẽ đổi mật khẩu truy cập của email HUTECH.
        </p>
      </div> -->
    </div>

    <!-- (Pending Request) -->
    @if(emailRecoveryHUTECH.requestInfo.status == _RECOVERY_EMAIL_HUTECH_CONST.STATUS.DANG_XU_LY) {

    <div class="alert alert-warning">
      <div class="d-flex flex-start w-100">
        <div class="mr-2 hidden-md-down">
          <span class="icon-stack icon-stack-lg">
            <i class="base base-6 icon-stack-3x opacity-100 color-warning-500"></i>
            <i class="base base-10 icon-stack-2x opacity-100 color-warning-300 fa-flip-vertical"></i>
            <i class="fal fa-spin fa-sync icon-stack-1x fs-lg opacity-100 color-white"></i>
          </span>
        </div>
        <div class="d-flex flex-fill">
          <div class="flex-fill">
            <span class="h5">Đang xử lý yêu cầu</span>
            <br>
            Bộ phận hỗ trợ đã tiếp nhận và sẽ xử lý yêu cầu khôi phục mật khẩu của bạn. Vui lòng quay lại sau để kiểm
            tra kết quả.
          </div>
        </div>
      </div>
    </div>
    }

    <!-- (Compelete Request) -->
    @if( (emailRecoveryHUTECH.requestInfo.status == _RECOVERY_EMAIL_HUTECH_CONST.STATUS.DA_XU_LY) && !isExpired) {
    <div class="alert alert-success">
      <div class="d-flex flex-start w-100">
        <div class="mr-2 hidden-md-down">
          <span class="icon-stack icon-stack-lg">
            <i class="base base-6 icon-stack-3x opacity-100 color-success-500"></i>
            <i class="base base-10 icon-stack-2x opacity-100 color-success-300 fa-flip-vertical"></i>
            <i class="fal fa-check-circle icon-stack-1x opacity-100 color-white"></i>
          </span>
        </div>
        <div class="d-flex flex-fill">
          <div class="flex-fill">
            <span class="h5">Mật khẩu đã được khôi phục</span>
            <br>
            <!-- Password Display -->
            <div class="password-display mt-1">
              <div class="password-header">
                <span class="password-label">Mật khẩu mới:</span>
                <button (click)="copyToClipboard()" class="copy-button">
                  <svg class="icon-sm" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                      d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                  </svg>
                  Sao chép
                </button>
              </div>
              <div class="password-value">
                {{ emailRecoveryHUTECH.requestInfo.passText }}
              </div>
            </div>

            <!-- Timer Warning -->
            <div class="timer-warning">
              <div class="timer-header">
                <i class="fal fa-clock mr-1"></i>
                <span class="timer-label">Thời gian hiệu lực:</span>
                <app-countdown-timer 
                [targetTime]="emailRecoveryHUTECH.requestInfo.timeExpiry"
                (expired)="onCountdownExpired()"
                ></app-countdown-timer>
                <!-- <span class="timer-value fw-700">{{ emailRecoveryHUTECH.requestInfo.timeExpiry }}</span> -->
              </div>
              <p class="timer-description">
                Mật khẩu này chỉ có hiệu lực trong thời gian giới hạn. Hãy dùng để truy cập email và đổi mật khẩu mới
                ngay.
              </p>
            </div>
            <!-- <div class="alert alert-danger">
              <div class="fw-500">
                <i class="fal fa-clock mr-1"></i>
                <span class="timer-label">Thời gian hiệu lực:</span>
                <span class="timer-value fw-700">{{ emailRecoveryHUTECH.requestInfo.timeExpiry }}</span>
              </div>
              <p class="timer-description">
                Mật khẩu này chỉ có hiệu lực trong thời gian giới hạn. Hãy dùng để truy cập email và đổi mật khẩu mới
                ngay.
              </p>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    }

    @if(emailRecoveryHUTECH.requestInfo.status != _RECOVERY_EMAIL_HUTECH_CONST.STATUS.DANG_XU_LY) {
    <div class="action-buttons">
      <button (click)="handleRequestRecovery()" [disabled]="isSubmitting" [ngClass]="{
        'cursor-default': isSubmitting
        }" class="btn btn-primary">
        <svg *ngIf="!isSubmitting" class="icon-sm" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
            d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
        </svg>
        <svg *ngIf="isSubmitting" class="icon-sm icon-spin" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
          <path class="opacity-75" fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
        </svg>
        @if(isSubmitting) {
        Đang gửi yêu cầu...
        }@else {
        @if(emailRecoveryHUTECH.requestInfo.status == _RECOVERY_EMAIL_HUTECH_CONST.STATUS.DA_XU_LY) {
        Gửi yêu cầu mới
        }@else {

        Yêu cầu khôi phục mật khẩu
        }
        }
      </button>

    </div>
    }

    <!-- Help Section -->
    <div class="help-section">
      <p class="fs-xs">
        Cần hỗ trợ? Liên hệ {{boPhanSupport}} qua Email:
        <a href="mailto:{{emailSupport}}" class="help-link">{{emailSupport}}</a>
        hoặc điện thoại: <strong> <a href="callto:{{phoneSupport}}" class="help-link">{{phoneSupport}}</a></strong>
      </p>
    </div>
  </div>

  }@else {
  <!-- Feature Not Available -->
  <div class="feature-unavailable">
    <div class="feature-unavailable-content">
      <svg class="feature-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
          d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      <h2 class="feature-title">Chức năng đang phát triển</h2>
      <p class="feature-description">
        Tính năng khôi phục mật khẩu Email HUTECH hiện chưa khả dụng.
        <!-- <br />
          Vui lòng liên hệ {{boPhanSupport}} để được hỗ trợ. -->
      </p>
      <!-- <div class="feature-contact">
          <p>
            Email: <a href="mailto:{{emailSupport}}" class="help-link">{{emailSupport}}</a>
            <br />
            Điện thoại: <strong>{{phoneSupport}}</strong>
          </p>
        </div> -->
    </div>
  </div>
  }


</div>
